import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '../../../@core/services/authentication.service';
import { first } from 'rxjs/operators';

@Component({
  selector: 'ngx-app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  model: any = {};
  errorMessage: string;
  returnUrl: string;
  logging: boolean;
  sessionExpired : boolean = false;
  
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.sessionExpired = params['sessionExpired'] === 'true';
    });
    const returnUrl = this.route.snapshot.queryParams['returnUrl'];
    this.returnUrl = returnUrl && returnUrl[0] === '/' && returnUrl[1] !== '/' && returnUrl !== '/login'
      ? returnUrl : '/';
    this.logging = false;
    if (localStorage.getItem("lastUserName")) {
      this.model.UserName = localStorage.getItem("lastUserName");
    }
  }

  login() {
    if (this.logging) { return; }
    this.logging = true;
    this.authenticationService
      .login(this.model.UserName, this.model.Password)
      .pipe(first())
      .subscribe(
        data => {
          this.logging = false;
          this.router.navigateByUrl(this.returnUrl);
        },
        error => {
          this.logging = false;
          console.log(error);
          alert('Échec de l\'authentification. Veuillez réessayer.');
        }
      );
  }
}
